module.exports = __webpack_public_path__ + "img/灵感.dbdf5cf6.webp";